// @flow

// ADS-6666 DMO competitor geos set for tracking, will end on Dec 2nd, should be removed after that
const DMO_COMPETITOR_GEOS: Set<number> = new Set([
  295424,
  294009,
  1940497,
  293997,
  293993,
  295398,
  298551,
  664891,
  293986,
  298570,
  28944,
  57592,
  55863,
  29998,
  31323,
  34882,
  54171,
  49648,
  31204,
  57201,
  58210,
  54135,
  36022,
  51963,
  47958,
  147374,
  147353,
  147414,
  147395,
  147267,
  147281,
  147379,
  147242,
  147401,
  292019,
  147342,
  291959,
  33501,
  33657,
  33701,
  57302,
  1509268,
  33651,
  33676,
  33191,
  33667,
  33311,
  59541,
  47170,
  33446,
  294311,
  189413,
  187879,
  190313,
  187464,
  54359,
  46686,
  46932,
  41298,
  34693,
  34296,
  46111,
  34141,
  40792,
  46809,
  34234,
  34571,
  53258,
  55879,
  34227,
  60927,
  46931,
  32469,
  29124,
  32279,
  32490,
  32286,
  34399,
  32513,
  34097,
  51790,
  32954,
  54283,
  34606,
  34393,
  1435792,
  33191,
  33433,
  45402,
  42499,
  47185,
  150770,
  147288,
  150771,
  150810,
  150795,
  147414,
  294310,
  147379,
  147267,
  291959,
  293738,
  32648,
  55879,
  7791276,
  34678,
  32655,
  34227,
  49023,
  45964,
  34296,
  55930,
  45953,
  34438,
  255055,
  298207,
  298566,
  1066456,
  298106,
  1066451,
  1066461,
  298224,
  298560,
  1066443,
  1066444,
  297908,
  255067,
  255098,
  6739933,
  55132,
  3632287,
  1534661,
  7210896,
  1113409,
  7734104,
  7208096,
  7176432,
  186216,
  189952,
  187768,
  191,
  187070,
  187275,
  187427,
  188045,
]);

export default DMO_COMPETITOR_GEOS;
